<script>
import ModelShow from '../models/show';
import Row from '@/components/models/show/custom-row';

export default {
  extends: ModelShow,
  page: {
    title: "Detail Vehicles",
  },
  props: {
    cardTitle: {default() { return this.lodash.startCase(this.$t('vehicles.singular')) }},
    resourceRoute: {default: 'vehicles'},
    modelVariable: {default: 'company'},
    denyEdit: {type: Boolean, default() { return !this.$auth.hasPermissionTo("vehicles.edit") }},
    denyDelete: {type: Boolean, default: true},
    columns: {
      type: Object,
      default() {
        return {
          [this.modelVariable || 'model']: [
            {
              key: 'key',
              label: this.$t('models.key'),
              component: Row
            }
          ]
        };
      }
    },
  },
  data() {
    return {
      title: this.lodash.startCase(this.$t('vehicles.plural')),
    }
  },
  mounted() {
    this.fetchModel();
  },
  computed: {
    items() {
      return [
        {
          text: this.lodash.startCase(this.$t('vehicles.plural')),
          href: "/vehicles",
        },
        {
          text: this.model && this.model.id ? this.model['name'] : this.$route.params.key,
          href: `/vehicles/${this.$route.params.key}`,
          active: true,
        }
      ]
    },
    modelMapped() {
      return this.lodash.isEmpty(this.model) ? [] : [{
        key: this.lodash.startCase(this.$t(`${this.resourceRoute}.name`)),
        item: this.model,
        value: {
          props: { item: {type: Object, default: () => {}} },
          computed: {
            customLabel() {
              let label = this.item.name

              if (this.item.type === 'heavy') label = this.$t('vehicles.truck')
              else if (this.item.type === 'medium') label = this.$t('vehicles.crank_truck')
              else if (this.item.type === 'light') label = this.$t('vehicles.pickup')

              return label
            }
          },
          template: `<span v-html="lodash.upperFirst(customLabel) || '-'"></span>`
        },
        class: 'row',
        labelClass: 'col-sm-12 col-md-3',
        valueClass: 'col-sm-12 col-md-9',
        showColon: true,
      }, {
        key: this.lodash.startCase(this.$t(`${this.resourceRoute}.license_plate`)),
        value: this.model.license_plate,
        class: 'row',
        labelClass: 'col-sm-12 col-md-3',
        valueClass: 'col-sm-12 col-md-9',
        showColon: true,
      }, {
        key: this.lodash.startCase(this.$t(`models.description`)),
        item: this.model.description,
        value: {
          props: { item: {type: String, default: ''} },
          template: `<span v-html="item || '-'"></span>`
        },
        class: 'row',
        labelClass: 'col-sm-12 col-md-3',
        valueClass: 'col-sm-12 col-md-9',
        showColon: true,
      }]
    }
  },
  methods: {
    delete() {
      return this.$axios.delete(`/vehicles/${this.$route.params.key}`)
    },
    fetchModel() {
      this.loading = true;
      return this.$axios.get(`/vehicles/${this.$route.params.key}`).then((response) => {
        const { data: { data } } = response;
        this.model = data;
        return response;
      }).catch((error) => this.failedAlert(error))
      .finally(() => this.loading = false)
    }
  }
}
</script>
